let getIdTokenSilently = () => Promise.resolve();
let account = '';

// eslint-disable-next-line import/prefer-default-export
export const sec = {
  getIdTokenSilently: () => getIdTokenSilently,
  setIdTokenSilently: (func) => { getIdTokenSilently = func; },
  getAccount: () => account,
  setAccount: (acc) => { account = acc; },
};

export const getMe = () => fetch(`${import.meta.env.VITE_APP_URL_API}/app/auth/me`);
